import classNames from 'classnames';
import { Item } from 'vetrf-ui/dist/utils/type/profile-table/Item';
import { Row } from 'vetrf-ui/dist/utils/type/profile-table/Row';

type InfoTableProps = {
  itemList: Item[];
  rows: Row[];
  tableClassName?: string;
};
/** Replacement for vetrf-ui ProfileTable with adaptive markup for mobile */
export const InfoTable = ({ itemList, rows, tableClassName }: InfoTableProps) => {
  if (!rows?.length || !itemList?.length) {
    return null;
  }

  const [{ item }] = itemList;

  if (!item) {
    return null;
  }

  return (
    <div className={classNames('profile-user-info profile-user-info-striped', tableClassName)}>
      {rows.map(({ header: { key, title }, dataFormatter }) => (
        <div key={key} className="profile-info-row">
          <div className="profile-info-name">{title}</div>
          <div className="profile-info-value">{dataFormatter?.(item)}</div>
        </div>
      ))}
    </div>
  );
};
